import { Card, CardContent, Stack, Unstable_Grid2 as Grid } from '@mui/material';
import capitalize from 'lodash/capitalize';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { routeCreator as audienceRouteCreator } from '@occc-app/routes/Audience/utils';
import { Divider, InfoField, LinkChip } from '@occc-app/design-system';
import { MessagingCampaignDetailsFragment } from '@occc/graphql';

import {
  getScheduledDateLabel,
  getScheduledTimeLabel,
  localizeNumber,
} from '../../messaging-campaign-details.utils';
import { getMessagingCampaignTypeTitle } from '../../../../messaging-center.utils';

type GeneralInfoProps = {
  status: MessagingCampaignDetailsFragment['status'];
  channelsConfig: MessagingCampaignDetailsFragment['channelsConfig'];
  scheduleAt: MessagingCampaignDetailsFragment['scheduleAt'];
  audience: MessagingCampaignDetailsFragment['audience'];
};

export const GeneralInfo = ({ status, channelsConfig, scheduleAt, audience }: GeneralInfoProps) => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={3}>
          <Grid container columnSpacing={3} xs={12} sx={{ '& > :first-of-type': { pl: 0 } }}>
            <Grid xs={12} sm={3} md={3}>
              <InfoField label='Delivery Status' value={capitalize(status)} mb={0} />
            </Grid>
            <Grid xs={12} sm={3} md={3}>
              <InfoField
                label='Channels'
                value={getMessagingCampaignTypeTitle({ channels: channelsConfig, joinSymbol: '&' })}
                mb={0}
              />
            </Grid>
          </Grid>

          <Divider />

          <Grid
            container
            columnSpacing={3}
            xs={12}
            sx={{
              '& > :first-of-type': { pl: 0 },
              '& > :last-of-type': { pr: 0 },
            }}
          >
            <Grid xs={12} sm={3}>
              <InfoField label='Scheduled Date' value={getScheduledDateLabel(scheduleAt)} mb={0} />
            </Grid>
            <Grid xs={12} sm={3}>
              <InfoField label='Scheduled Time' value={getScheduledTimeLabel(scheduleAt)} mb={0} />
            </Grid>
            <Grid xs={12} sm={3}>
              <InfoField
                label='Target Audience'
                value={
                  audience ? (
                    <LinkChip
                      label={audience.name}
                      href={audienceRouteCreator.details(audience.uuid)}
                    ></LinkChip>
                  ) : null
                }
                mb={0}
              />
            </Grid>
            <Grid xs={12} sm={3}>
              <InfoField
                label='Audience Size'
                value={localizeNumber(audience?.membershipCount || 0)}
                mb={0}
              />
            </Grid>
          </Grid>
        </Stack>
      </CardContent>
    </Card>
  );
};
